import http, { base } from '@/config/http.js'
const namespace = 'pages'
const uri = base + '/' + namespace 

const pagesLoad = () =>
	http.get(uri)
		.then(({ data }) => data.data)
		.catch(error => {
			throw Error(`Failed to GET ${namespace} - ${error}`)
		})

const pagesCreate = params => http.post(uri, params)
const pagesUpdate = params => http.put(`${uri}/${params.id}`, params)

const pagesDelete = page => 
	http.delete(`${uri}/${page.id}`)
		.then(({data}) => data)
		.catch(error => {
			throw Error(`Failed to DELETE ${namespace} - ${error}`);
		})

const pagesFilesLoad = () =>
	http.get(base + '/pages/files')
		.then(({ data }) => data.data)
		.catch(error => {
			throw Error(`Failed to GET ${namespace} - ${error}`)
		})

const pagesFilesCreate = pageFile => 
	http.post(`${uri}/files`, pageFile)
		.then(({ data }) => data)
		.catch(error => {
			throw Error(`Failed to POST ${namespace} - ${error}`);
		})

const pagesFilesUpdate = pageFile => 
	http.put(`${uri}/files/${pageFile.id}`, pageFile)
		.then(({ data }) => data)
		.catch(error => {
			throw Error(`Failed to PUT ${namespace} - ${error}`);
		})

const pagesFilesDelete = pageFile => 
	http.delete(`${uri}/files/${pageFile.id}`)
		.then(({data}) => data)
		.catch(error => {
			throw Error(`Failed to DELETE ${namespace} - ${error}`);
		})

const snippetsLoad = () => http.get(base + '/snippets').then(res => res.data.data)
const snippetsCreate = snippet => http.post(base + '/snippets', snippet)	
const snippetsUpdate = snippet => http.put(`${base}/snippets/${snippet.id}`, snippet)		
const snippetsDelete = snippet => http.delete(`${base}/snippets/${snippet.id}`)
		
export default {
	pagesLoad,
	pagesCreate,
	pagesUpdate,
	pagesDelete,

	pagesFilesLoad,
	pagesFilesCreate,
	pagesFilesUpdate,
	pagesFilesDelete,

	snippetsLoad,
	snippetsCreate,
	snippetsUpdate,
	snippetsDelete,
}
